"use strict";
/**
 * The game picker's schedule (ai/nba/N8-taps/PLAN.md §11.2): the recorder's owner-only
 * GET /win-prob/nba/schedule. Never called by the pad, so a failure here never stops recording.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchNbaSchedule = fetchNbaSchedule;
const request_1 = require("./request");
/** One America/New_York date (YYYYMMDD). Throws when the schedule is unavailable (503). */
async function fetchNbaSchedule(date) {
    const response = await (0, request_1.apiRequest)("GET", "/win-prob/nba/schedule", { params: { date } });
    return response.data;
}
